var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"container-fluid"},[_c('h1',{staticClass:"main-title text-truncate"},[_vm._v(" "+_vm._s(_vm.$t("mainNav.devices"))+" ")]),_c('device-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }